import { useState, useEffect } from 'react';
import { detectUserLocation } from '../utils/privacyCompliance';

interface LocationData {
  state?: string;
  country: string;
  loading: boolean;
  error?: string;
}

export function useLocation() {
  const [location, setLocation] = useState<LocationData>({
    country: 'US',
    loading: true,
  });

  useEffect(() => {
    try {
      // First, check if we have location in localStorage (from previous detection)
      const cached = localStorage.getItem('userLocation');
      if (cached) {
        const parsed = JSON.parse(cached);
        setLocation({ ...parsed, loading: false });
        return;
      }

      // Default to US without state detection for MVP
      const defaultLocation = { country: 'US' };

      // Cache the result
      localStorage.setItem('userLocation', JSON.stringify(defaultLocation));

      setLocation({
        ...defaultLocation,
        loading: false,
      });
    } catch (error) {
      console.error('Failed to detect location:', error);
      setLocation({
        country: 'US',
        loading: false,
        error: 'Could not detect location',
      });
    }
  }, []);

  return location;
}

// Hook to manually set location (useful for testing or user selection)
export function useLocationSetter() {
  return (state: string) => {
    const location = { state, country: 'US' };
    localStorage.setItem('userLocation', JSON.stringify(location));
    // Trigger a custom event so other components can react
    window.dispatchEvent(new CustomEvent('locationChanged', { detail: location }));
  };
}
